export const COMPANY = 'company';
export const FUND = 'fund';
export const LISTED_COMPANY = 'listedCompany';
export const REAL_ESTATE = 'realEstate';
export const CRYPTO = 'crypto';
export const OTHER = 'other';

const INVESTMENT_ASSET = [
  COMPANY,
  FUND,
  LISTED_COMPANY,
  REAL_ESTATE,
  CRYPTO,
  OTHER,
];

export default INVESTMENT_ASSET;
